import { useSession } from '@/context/SessionProvider'
import { Box, Flex } from '@chakra-ui/react'
import { AudioSwitch } from '@/components/atoms/AudioSwitch'
import { UserBalance } from '@/components/atoms/UserBalance/UserBalance'
import { WalletButton } from '@/components/atoms/WalletButton/WalletButton'
import { UserProfile } from '@/components/molecules/UserProfile/UserProfile'
import { Logo } from '@/components/atoms/Logo/Logo'
import { DepositButton } from '@/components/atoms/DepositButton/DepositButton'

export const Navbar = () => {
  const { account } = useSession()

  return (
    <>
      <Flex
        borderBottom={'1px solid'}
        borderColor={'ninja.500'}
        py={4}
        px={6}
        alignItems={'center'}
        mx={'auto'}
        justifyContent={{ base: 'space-between', sm: 'end' }}
        h={'full'}
        gap={2}
      >
        <Box display={{ base: 'block', sm: 'none' }}>
          <Logo textStyles={{ fontSize: '22px', display: account ? 'none' : 'block' }} logoStyles={{ w: 10 }} />
        </Box>
        <Flex gap={2} alignItems={'center'}>
          {account && <DepositButton />}
          {account && <UserBalance />}
          {account && (
            <Box display={{ base: 'none', sm: 'block' }}>
              <AudioSwitch />
            </Box>
          )}
          {account && <UserProfile />}
          {!account && <WalletButton />}
        </Flex>
      </Flex>
    </>
  )
}
